export default __webpack_public_path__ + "static/media/logo_keolis.805213c3.svg";